import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  accountNumberSuffix: attr(String),
  accountType: attr(Number),
  bankName: attr(String),
  status: attr(Number)
});